import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import { PublicSvgIcon } from "~/components/public_svg_icon";
import { useAuthStatus } from "~/contexts/auth_query";

interface UserAvatarProps {
  isCollapsed: boolean;
  isMobile?: boolean;
}

export function UserAvatar({ isCollapsed, isMobile = false }: UserAvatarProps) {
  const { user } = useAuthStatus();

  const displayName =
    `${user?.profile?.given_name ?? ""} ${user?.profile?.family_name ?? ""}`.trim() ||
    "User";

  const avatarIcon = (
    <PublicSvgIcon
      name="avatar"
      colorOverride="common.white"
      size={24}
      data-testid="user-avatar"
    />
  );

  if (isCollapsed) {
    return (
      <Tooltip title={displayName} placement="right">
        <Box sx={{ mb: 2 }}>{avatarIcon}</Box>
      </Tooltip>
    );
  }

  return (
    <Stack
      direction="row"
      gap={1}
      alignItems="center"
      sx={{
        mb: isCollapsed ? 2 : 3,
        py: isCollapsed ? 1 : 0,
        px: isMobile ? 2.5 : 3,
        width: "100%",
        height: isCollapsed ? 6 : "auto",
      }}
    >
      {avatarIcon}
      <Typography variant="body2" noWrap>
        {displayName}
      </Typography>
    </Stack>
  );
}
